<template>
  <section class="widget widget-goals" :class="[{ [`widget-${type}`]: type }]">
    <h3 class="widget-title">
      {{
        `¿Qué logró su publicidad digital ${
          $route.params.productName
            ? `en ${change($route.params.productName)}`
            : ""
        }?`
      }}
    </h3>
    <div class="cards-wrapper">
      <card type="goals">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="eye" />
          </div>
          <h4 class="card-title" v-if="$route.params.businessUnitId == 3">
            Impresiones Totales
          </h4>
          <h4 v-else class="card-title">Impresiones</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalImpressions) }}</h1>
          <p>{{ wording.Impressions }}</p>
        </div>
      </card>
      <card type="goals">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="mouse-pointer" />
          </div>
          <h4 v-if="$route.params.businessUnitId == 3" class="card-title">
            Clicks Totales
          </h4>
          <h4 v-else class="card-title">Clicks</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalClicks) }}</h1>
          <p>{{ wording.Clicks }}</p>
        </div>
      </card>
      <card
        type="goals"
        v-if="
          totalCallClicks != 0 &&
            totalCallClicks !== null &&
            totalCallClicks !== undefined
        "
      >
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="mouse-pointer" />
          </div>
          <h4 class="card-title">Llamadas</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalCallClicks) }}</h1>
          <p>{{ wording.CallLabel }}</p>
        </div>
      </card>
      <card
        type="goals"
        v-if="
          totalClicksAddress != 0 &&
            totalClicksAddress !== null &&
            totalClicksAddress !== undefined
        "
      >
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="mouse-pointer" />
          </div>
          <h4 class="card-title">Click a la Dirección</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalClicksAddress) }}</h1>
          <p>{{ wording.DirectionLabel }}</p>
        </div>
      </card>
      <card
        type="goals"
        v-if="
          totalSearchImpressions != 0 &&
            totalSearchImpressions !== null &&
            totalSearchImpressions !== undefined
        "
      >
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="mouse-pointer" />
          </div>
          <h4 class="card-title">Búsquedas</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalSearchImpressions) }}</h1>
          <p>{{ wording.SearchImpressionsLabel }}</p>
        </div>
      </card>
      <card
        type="goals"
        v-if="
          totalMapImpressions != 0 &&
            totalMapImpressions !== null &&
            totalMapImpressions !== undefined
        "
      >
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="mouse-pointer" />
          </div>
          <h4 class="card-title">Te Vieron</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalMapImpressions) }}</h1>
          <p>{{ wording.MapImpressionsLabel }}</p>
        </div>
      </card>
      <card
        type="goals"
        v-if="
          totalWebsiteClicks != 0 &&
            totalWebsiteClicks !== null &&
            totalWebsiteClicks !== undefined
        "
      >
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="mouse-pointer" />
          </div>
          <h4 class="card-title">Click al Website</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalWebsiteClicks) }}</h1>
          <p>{{ wording.WebsiteClickslabel }}</p>
        </div>
      </card>
      <card
        type="goals"
        v-if="
          totalReviewCount != 0 &&
            totalReviewCount !== null &&
            totalReviewCount !== undefined
        "
      >
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="mouse-pointer" />
          </div>
          <h4 class="card-title">Reseñas</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalReviewCount) }}</h1>
          <p>{{ wording.ReviewAccounLabel }}</p>
        </div>
      </card>
      <card
        type="goals"
        v-if="
          totalDirectionRequest != 0 &&
            totalDirectionRequest !== null &&
            totalDirectionRequest !== undefined
        "
      >
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="mouse-pointer" />
          </div>
          <h4 class="card-title">Click a la Dirección</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalDirectionRequest) }}</h1>
          <p>{{ wording.DirectionRequestlabel }}</p>
        </div>
      </card>
      <card
        type="goals"
        v-if="
          totalViews != 0 && totalViews !== null && totalViews !== undefined
        "
      >
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="play" />
          </div>
          <h4 class="card-title">Visualizaciones</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalViews) }}</h1>
          <p>{{ wording.Views }}</p>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
export default {
  name: "ads-goals",
  props: {
    type: String,
    totalImpressions: Number,
    totalCallClicks: {
      type: Number,
      default: 0
    },
    totalDirectionRequest: {
      type: Number,
      default: 0
    },
    totalClicks: {
      type: Number,
      default: 0
    },
    totalViews: {
      type: Number,
      default: 0
    },
    totalWebsiteClicks: {
      type: Number,
      default: 0
    },
    totalSearchImpressions: {
      type: Number,
      default: 0
    },
    totalMapImpressions: {
      type: Number,
      default: 0
    },
    totalClicksAddress: {
      type: Number,
      default: 0
    },
    totalReviewCount: {
      type: Number,
      default: 0
    },
    totalCTR: Number,
    wording: Object,
    IsInfopaginas: Boolean,
    cardHeaderName: String,
    cardFooterDescription: String
  },
  data() {
    return {};
  },
  methods: {
    change(ProductName) {
      if (ProductName === "AnunciosdebúsquedaenGoogle") {
        return "Anuncios de búsqueda en Google";
      } else if (ProductName === "Paginasamarillas.com.do") {
        return "Paginasamarillas.com.do";
      } else if (ProductName === "AnunciosdeMáximoRendimiento") {
        return "Anuncios Máximo Rendimiento de Google";
      } else if (ProductName === "SocialMediaPost") {
        return "Social Media Post";
      } else if (ProductName === "AnunciosdeYoutube") {
        return "Anuncios de Youtube";
      } else if (ProductName === "AnunciosdeRedesSociales") {
        return "Anuncios de Redes Sociales";
      } else if (ProductName === "AnunciosdeDisplayenGoogle") {
        return "Anuncios de Display en Google";
      } else if (ProductName === "CampañasLocales") {
        return "Anuncios de Campañas Locales";
      } else if (ProductName === "SuWebsite") {
        return "Su Website";
      } else if (ProductName === "GoogleMyBusiness") {
        return "Google My Business";
      } else if (ProductName === "SpotifyAds") {
        return "Spotify Ads";
      } else if (ProductName === "LinkedInAds") {
        return "Linkedin Ads";
      } else if (ProductName === "GoogleCampaigns") {
        return "Google Campaigns";
      } else {
        return ProductName;
      }
    },
    numberLetter(value) {
      let suffixes = [
        "U",
        "D",
        "C",
        "K",
        "K",
        "K",
        "M",
        "M",
        "M",
        "B",
        "B",
        "B",
        "T",
        "T",
        "T"
      ];

      let stringValue = value ? value.toString() : "0";
      let valueLength = stringValue.length;
      let suffix = suffixes[valueLength - 1];

      const BASEDIVISOR = 3;
      let startindex = 0;
      let characterToTake = valueLength % BASEDIVISOR;
      characterToTake = characterToTake == 0 ? BASEDIVISOR : characterToTake;

      if (valueLength > BASEDIVISOR) {
        let wholePart = stringValue.substr(startindex, characterToTake);
        let decimalPart = stringValue.substr(
          startindex + characterToTake,
          BASEDIVISOR
        );

        let firstDecimal = decimalPart.substr(startindex, 1);

        let wholeNumber =
          firstDecimal != "0"
            ? wholePart + "." + decimalPart.substr(startindex, 1) + suffix
            : wholePart + suffix;

        return wholeNumber;
      }

      return stringValue;
    }
  }
};
</script>
<style lang="scss" scoped>
.widget {
  &.widget-goals {
    .card-goals {
      .card-content {
        text-align: center;
        h1 {
          span {
            font-size: 35px;
          }
          font-size: 52px;
          font-weight: $font-medium;

          color: $highlight-color;
        }
      }
    }
  }
  &.brand-impact {
    .card-line-chart {
      .card-top {
        .card-number {
          text-align: center;
          h3 {
            color: $highlight-color;
          }
        }
      }
    }
  }
}
@include respond-above(sm) {
  .widget {
    &.widget-goals {
      .cards-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
      }
    }
  }
}
</style>
